import { unref } from 'vue';
import {
  absolutePrice,
  addThousandSeparators,
  amountPropertiesToUnit,
  amountToUnit,
  comparePrices,
  formatPrice,
  getCurrencySymbol,
  subtractPrices,
  sumPrices,
  toMinorUnitProperties,
  toUnit,
  getConvertedPrice as getConvertedPriceUtil,
  getCurrencyPriceConversion as getCurrencyPriceConversionUtil,
} from '@core/utilities/price';
import useCurrency from '@core/composables/use-currency';
import { Amount } from '@core/types/amount';
import { useI18n } from 'vue-i18n';
import rootStoreHelpers from '@monolith/legacy/store/helpers';

const usePrice = () => {
  const { getCurrencyRate } = rootStoreHelpers.useGetters(['getCurrencyRate']);
  const { locale: i18nLocale } = useI18n();
  const { $currency } = useCurrency();

  return {
    absolutePrice,
    addThousandSeparators,
    amountPropertiesToUnit,
    amountToUnit,
    comparePrices,
    formatPrice: (price: Amount, format = '$0.00', locale: string = unref(i18nLocale)) => formatPrice(price, format, locale),
    subtractPrices,
    sumPrices: (prices: Amount[]) => sumPrices(prices, $currency.value),
    toMinorUnitProperties,
    toUnit,
    getCurrencySymbol,
    getCurrencyPriceConversion: getCurrencyPriceConversionUtil,
    getConvertedPrice: async (price: Amount) =>
      await getConvertedPriceUtil(price, $currency.value, getCurrencyRate.value(price.currency, $currency.value)),
  };
};

export default usePrice;
